<template>
  <div>
    <el-button v-if="type != ''" type="text" style="font-size: 15px !important;" @click="edit">{{ type == 1 ? '不足一箱' : '计算规则' }}</el-button>
    <!-- 设置 S -->
    <dialog-form :ref-obj.sync="formInfo.ref"
                 width="60%"
                 permission="goodsManage"
                 :data="formInfo.data"
                 :fileList="formFieldList"
                 :labelWidth="formInfo.labelWidth"
                 :ruleList="formInfo.rules"
                 :dialogTitle="title"
                 :dialogVisible="formDialog.visibel"
                 :handleClose="handleFormClose"
                 :footer="true">
        <template v-slot:form-smallestUnit>
            <el-radio v-model="formInfo.data.smallestUnit" :label="0">按件</el-radio>
            <el-radio v-model="formInfo.data.smallestUnit" :label="1">按箱(不足一箱算一箱)</el-radio>
        </template>
        <template v-slot:form-smallestRule>
            <div class="section">
                <p><span>0~0.5(含0.5)</span> -- </p>
                <el-select v-model="formInfo.data.smallestRule.a" placeholder="请选择">
                <el-option
                    v-for="item in calRulesSelect"
                    :key="item.code"
                    :label="item.label"
                    :value="item.value">
                </el-option>
                </el-select>
            </div>
            <div class="section">
                <p><span>0.5~1(不含1)</span> -- </p>
                <el-select v-model="formInfo.data.smallestRule.b" placeholder="请选择">
                <el-option
                    v-for="item in calRulesSelect"
                    :key="item.code"
                    :label="item.label"
                    :value="item.value">
                </el-option>
                </el-select>
            </div>
            <div class="section">
                <p><span>≥1</span> -- </p>
                <el-select v-model="formInfo.data.smallestRule.c" placeholder="请选择">
                  <el-option label="按实际值算" :value="4"></el-option>
                  <el-option label="零数按上两条规则计算" :value="5"></el-option>
                </el-select>
            </div>
        </template>
        <template v-slot:footerBtns>
                <el-button @click="handleFormClose">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
        </template>
    </dialog-form>
    <!-- 设置 E -->
  </div>
</template>

<script>
import dialogForm from '@/components/Form/DialogForm'
export default {
  props: ['type', 'formInfos'],
  components: {
    dialogForm
  },
  data () {
    return {
      formInfo: {
        ref: null,
        data: {
          smallestUnit: '',
          smallestRule: {
            a: '',
            b: '',
            c: ''
          }
        },
        rules: {},
        labelWidth: '150px'
      },
      formDialog: {
        title: this.title || '编辑不足一箱',
        visibel: false
      },
      // 下拉框
      calRulesSelect: [
        {label: '不计费', value: 1},
        {label: '按0.5方/吨算', value: 2},
        {label: '按1方/吨算', value: 3},
        {label: '按实际值算', value: 4}
      ]
    }
  },
  mounted () {
  },
  methods: {
    // 配置不足一箱、计算规则
    edit () {
      this.formDialog.visibel = true
    },
    submitForm () {
      this.$emit('update', this.formInfo.data)
      this.handleFormClose()
    },
    // 关闭弹窗
    handleFormClose () {
      if (this.formInfo.ref) {
        this.formInfo.ref.clearValidate()
      }
      this.formInfo.data = {
        smallestUnit: '',
        smallestRule: {
          a: '',
          b: '',
          c: ''
        }
      }
      this.formDialog.visibel = false
    }
  },
  computed: {
    title () {
      return this.type === '1' ? '编辑不足一箱' : '编辑计算规则'
    },
    formFieldList () {
      let arr = [
        {label: this.formInfos.ceshi2 === '1' ? '不足一箱' : '最小计算单位', prop: 'smallestUnit', type: 'slot', required: true}
      ]
      if (this.formInfos.ceshi2 === '2') {
        arr.push(
          {label: '重量体积计算规则', prop: 'smallestRule', type: 'slot', required: true}
        )
      }
      return arr
    }
  },
  watch: {
    'formDialog.visibel': {
      deep: true,
      handler (val) {
        if (val) {
          let {smallestRule, smallestUnit} = JSON.parse(JSON.stringify(this.formInfos))
          this.formInfo.data.smallestRule = smallestRule
          this.formInfo.data.smallestUnit = smallestUnit
        }
      }
    }
  }
}
</script>

<style scoped>

  .section {
    display: flex;
    max-width: 300px;
  }
  .section p {
    margin-right: 15px;
  }
  .section p span {
    width: 110px;
    display: inline-block;
    text-align: center;
  }
  .section  >>> .el-select {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/page/goodsManage/components/costConfig.vue